
import * as _ from 'lodash'
import {ISourceCustomerProvider} from "./PA.MD.Services.IF"
import {PASearch} from "../PA.Core/PASearch"
import * as hash from "object-hash"
import {cache} from "webpack";


interface IRequestCacheEntry {
  key: string,
  param: any,
  results: number[]
}

export class SourceCustomerService implements ISourceCustomerProvider {

  static dctResponseCache: {[id:string]: IRequestCacheEntry} = {}

  getSrcCustIdsbyParent(arrParentIds: number[], SalesOrg?: string, Division?: string, DistribChannel?: string): Promise<number[]> {
    const self = this;


    return new Promise<number[]>((resolve, error) => {
      //debugger
      let sSalesOrgs: string[] = []
      let sDivisions: string[] = []
      let sDistribChannels: string[] = []

      if (!_.isEmpty(SalesOrg)) {
        sSalesOrgs.push(SalesOrg)
        sSalesOrgs.push('All')
      }

      if(!_.isEmpty(Division)){
        sDivisions.push(Division)
        sDivisions.push('All')
      }

      if(!_.isEmpty(DistribChannel)){
        sDistribChannels.push(DistribChannel)
        sDistribChannels.push('All')
      }

      let sParams:any = {}
      sParams.WB_Cust_Id_Planning = {"inq": arrParentIds}

      if (sSalesOrgs.length > 0) {
        sParams.SalesOrg = {"inq": sSalesOrgs }
      }

      if (sDivisions.length > 0){
        sParams.Division = {"inq": sDivisions}
      }

      if (sDistribChannels.length > 0){
        sParams.DistribChannel = {"inq": sDistribChannels}
      }

      let hashValue = hash(sParams)
      if(hashValue in SourceCustomerService.dctResponseCache){
        let cacheEntry = SourceCustomerService.dctResponseCache[hashValue]
        resolve(cacheEntry.results)
        return
      }

      let colSpecs= {WB_Cust_Id_Planning: {type: 'number'},
                     SalesOrg: {type: 'string'},
                     Division: {type: 'string'},
                     DistribChannel: {type: 'string'} }

      PASearch.find("vWB_Cust_SrcPlnR",sParams, colSpecs,[],0,['WB_Cust_Id_Source'])
        .then((results) => {
          let returnResults = <number[]> _.map(results,'WB_Cust_Id_Source')
          SourceCustomerService.dctResponseCache[hashValue] = {
            key: hashValue,
            param: sParams,
            results: returnResults
          }
          resolve(returnResults)
      }).catch((err) => {
        error(err)
      })

    })
  }
}






